"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const react_dropzone_1 = require("react-dropzone");
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Movie_1 = __importDefault(require("@material-ui/icons/Movie"));
const styles_1 = require("@material-ui/core/styles");
const common_1 = require("../../utils/common");
const lodash_1 = __importDefault(require("lodash"));
const FieldHeader_1 = __importDefault(require("./FieldHeader"));
const DialogWrapperWeb_1 = __importDefault(require("../Common/DialogWrapperWeb"));
const uuid_1 = require("uuid");
const CommonWeb_1 = require("./CommonWeb");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const theme_1 = require("../../styles/theme");
const TGRadioFieldWeb_1 = __importDefault(require("./TGRadioFieldWeb"));
const TGPreviewFieldWeb_1 = __importDefault(require("./TGPreviewFieldWeb"));
var Capture;
(function (Capture) {
    Capture["UPLOAD"] = "0";
    Capture["DEVICE_CAMERA"] = "1";
})(Capture || (Capture = {}));
var CameraOptions;
(function (CameraOptions) {
    CameraOptions["SYSTEM_CAMERA"] = "1";
})(CameraOptions || (CameraOptions = {}));
const CaptureArea = props => {
    const { captureLabel, fileUploadLabel, deviceUploadLabel, captureType, setCaptureType, camera, setCamera } = props;
    const captureAreaStyles = useCaptureAreaStyles();
    return (react_1.default.createElement("div", { className: clsx_1.default(captureType !== Capture.DEVICE_CAMERA && captureAreaStyles.container) },
        react_1.default.createElement("div", { className: clsx_1.default(captureType === Capture.DEVICE_CAMERA && captureAreaStyles.container) },
            react_1.default.createElement(TGRadioFieldWeb_1.default, { label: captureLabel, options: [
                    {
                        value: Capture.UPLOAD,
                        label: fileUploadLabel,
                    },
                    {
                        value: Capture.DEVICE_CAMERA,
                        label: deviceUploadLabel,
                    },
                ], defaultValue: Capture.UPLOAD, onChange: (x) => setCaptureType(x.target.value) })),
        captureType === Capture.DEVICE_CAMERA && (react_1.default.createElement(TGRadioFieldWeb_1.default, { value: camera, className: captureAreaStyles.dropdown, label: 'Select camera', options: [
                {
                    value: CameraOptions.SYSTEM_CAMERA,
                    label: 'System camera',
                },
            ], onChange: (evt) => {
                setCamera(evt.target.value);
            } }))));
};
const useCaptureAreaStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    dropdown: {
        width: '250px',
        marginBottom: '20px',
    },
    container: {
        marginBottom: 20
    }
}));
const UploadCount = props => {
    const { min, max, length, readOnly } = props;
    const uploadCountStyles = useUploadCountStyles();
    return (react_1.default.createElement("div", { className: uploadCountStyles.container },
        react_1.default.createElement(core_1.Typography, { className: readOnly ? clsx_1.default(uploadCountStyles.texts, uploadCountStyles.lastChild) : uploadCountStyles.texts, display: "inline" },
            react_1.default.createElement("span", { className: uploadCountStyles.addedText },
                `${length} added`,
                " ")),
        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { className: uploadCountStyles.texts },
                react_1.default.createElement("span", { className: uploadCountStyles.requiredText }, "Required"),
                react_1.default.createElement("span", { className: uploadCountStyles.symbolText }, `: ${min}`)),
            react_1.default.createElement(core_1.Typography, { className: clsx_1.default(uploadCountStyles.texts, uploadCountStyles.lastChild) },
                react_1.default.createElement("span", { className: uploadCountStyles.requiredText }, "Allowed"),
                react_1.default.createElement("span", { className: uploadCountStyles.symbolText }, `: ${max > -1 ? max : 'unlimited'}`))))));
};
const useUploadCountStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    texts: {
        display: 'inline-flex',
        marginRight: 10,
    },
    lastChild: {
        marginRight: 0,
    },
    container: {
        height: 19,
    },
    requiredText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
    },
    symbolText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
    numberText: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: 'normal',
    },
    addedText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
}));
const DropZone = props => {
    const { dragLabel, allowedTypes, updateFileList, error, mediaType } = props;
    const extensions = common_1.useExtensions(allowedTypes, ',');
    const extensionsLabel = common_1.useExtensions(allowedTypes, ' | ');
    const dropZoneStyles = useDropzoneStyles();
    const { getRootProps, getInputProps, isDragActive } = react_dropzone_1.useDropzone({ onDrop: updateFileList, noClick: true });
    let icon = react_1.default.createElement(AddPhotoAlternate_1.default, { style: styles.addIcon });
    if (mediaType === 'video' || mediaType === 'audio')
        icon = react_1.default.createElement(Movie_1.default, null);
    return (react_1.default.createElement("div", Object.assign({ className: clsx_1.default(dropZoneStyles.fileuploader, isDragActive && dropZoneStyles.dragActive) }, getRootProps()),
        react_1.default.createElement("div", { id: "upload-label", className: dropZoneStyles.container },
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "81", height: "50", viewBox: "0 0 81 50", fill: "none" },
                react_1.default.createElement("path", { d: "M65.3063 18.6391C63.0112 8.11084 52.785 0.207031 40.5 0.207031C30.7463 0.207031 22.275 5.21176 18.0562 12.5357C7.8975 13.5123 0 21.294 0 30.7236C0 40.8246 9.07875 49.0336 20.25 49.0336H64.125C73.44 49.0336 81 42.1979 81 33.7753C81 25.7189 74.0813 19.1884 65.3063 18.6391ZM47.25 27.672V39.8786H33.75V27.672H23.625L40.5 12.4137L57.375 27.672H47.25Z", fill: "black", "fill-opacity": "0.25" }))),
        react_1.default.createElement("div", { className: dropZoneStyles.titleContainer },
            react_1.default.createElement(core_1.Typography, { className: [dropZoneStyles.title, dropZoneStyles.titleColor].join(' ') }, dragLabel),
            react_1.default.createElement(core_1.Typography, { className: [dropZoneStyles.title, dropZoneStyles.orText].join(' ') }, "or"),
            react_1.default.createElement("input", Object.assign({}, getInputProps(), { accept: extensions, style: styles.none, id: "contained-button-file", onChange: (evt) => {
                    const files = lodash_1.default.get(evt, 'target.files');
                    updateFileList(files);
                }, multiple: true, type: "file" })),
            react_1.default.createElement("label", { htmlFor: "contained-button-file" },
                react_1.default.createElement(core_1.Button, { variant: "contained", color: "default", className: dropZoneStyles.uploadbtn, startIcon: icon, component: "span" }, "Upload")),
            react_1.default.createElement(core_1.Typography, { className: clsx_1.default(dropZoneStyles.title, dropZoneStyles.formats) }, extensionsLabel),
            error && react_1.default.createElement(core_1.Typography, { className: dropZoneStyles.errorText }, error))));
};
const useDropzoneStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    fileuploader: {
        padding: '43.206px 129px 42.968px 128px',
        border: `1px dashed ${theme_1.colors.black35}`,
        background: theme_1.colors.lotion,
        marginTop: 12,
        borderRadius: 6,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            padding: '43px 50px',
        },
    },
    dragActive: {
        border: `4px dashed ${theme.palette.primary.main}`,
    },
    title: {
        position: 'relative',
        textAlign: 'center',
        lineHeight: 'normal',
    },
    titleContainer: { width: '100%', margin: 'auto', textAlign: 'center' },
    titleColor: {
        color: theme_1.colors.black54,
        fontWeight: 300,
        fontSize: 20,
    },
    orText: {
        padding: '14px 0px',
        color: theme_1.colors.dimGray,
        fontSize: 16,
        fontWeight: 300,
    },
    container: { width: '200px', margin: 'auto', textAlign: 'center' },
    uploadbtn: {
        lineHeight: '100%',
        marginBottom: 12,
        color: theme_1.colors.black0,
        fontSize: 14,
        fontWeight: 500,
        boxShadow: `0px 2px 4px 0px ${theme_1.colors.black15}`,
        borderRadius: 5,
        '&:hover': {
            boxShadow: `0px 2px 4px 0px ${theme_1.colors.black15}`,
        },
    },
    formats: {
        fontSize: '14px',
        fontWeight: 300,
        color: theme_1.colors.black35,
        lineHeight: 'normal',
    },
    errorText: {
        color: theme_1.colors.danger,
        position: 'relative',
        textAlign: 'center',
        marginTop: '30px',
    },
}));
const styles = {
    addIcon: {
        color: theme_1.colors.black54,
    },
    none: {
        display: 'none',
    },
};
const HEADER_FOOTER_HEIGHT = 140;
const BODY_PADDING_SPACE = 45;
const useMediaFieldStyles = styles_1.makeStyles((theme) => ({
    content: {
        padding: '22px 34px',
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100vh - ${HEADER_FOOTER_HEIGHT}px - ${BODY_PADDING_SPACE}px)`,
        overflowY: 'auto',
        boxSizing: 'border-box',
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT + 1)]: {
            padding: '22px',
            height: `calc(100% - ${HEADER_FOOTER_HEIGHT}px)`,
        },
        '&::-webkit-scrollbar': {
            width: 7,
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: 5,
            backgroundColor: theme_1.colors.scrollBar,
        },
    },
    formHelpers: {
        height: '100%',
        width: '100%',
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT + 1)]: {
            height: '100%',
        },
    },
}));
const TGMediaFieldWeb = props => {
    const { addFiles, removeFiles, toggleModal, files } = props;
    const [captureType, setCaptureType] = react_1.useState(Capture.UPLOAD);
    const [uploadError, setUploadError] = react_1.useState(null);
    const [fileList, setFileList] = react_1.useState(files || []);
    const [addedFiles, setAddedFiles] = react_1.useState([]);
    const [removedFiles, setRemovedFiles] = react_1.useState([]);
    const [camera, setCamera] = react_1.useState(CameraOptions.SYSTEM_CAMERA);
    const classes = useMediaFieldStyles();
    const onDonePress = () => {
        addFiles(fileList.filter((x) => addedFiles.find((id) => id === x.id)));
        removeFiles(removedFiles);
        toggleModal && toggleModal();
    };
    const onDeleteFile = (id) => {
        setFileList(fileList.filter(x => x.id !== id));
        setRemovedFiles([...removedFiles, id]);
    };
    const onCancelPress = () => {
        toggleModal && toggleModal();
    };
    const { label, captureLabel, fileUploadLabel, deviceUploadLabel, dragLabel, allowedTypes, limitInMb, min, max, renderMedia, mediaType, } = props;
    const isValidLimit = (size) => size / 1024 / 1024 <= limitInMb;
    const addFileToList = (file) => {
        updateFileList([file]);
    };
    const updateFileList = (fileObjects) => {
        if (fileObjects && fileObjects.length) {
            const files = [...fileObjects];
            if (!files.every(file => isValidLimit(file.size))) {
                setUploadError(`Oops, the selected file is over the ${limitInMb} mb limit. Please choose a smaller file`);
                return;
            }
            setUploadError(null);
            const list = files.map((file) => {
                const splitPath = file.name.split('.');
                const extension = splitPath[splitPath.length - 1];
                return {
                    id: `${uuid_1.v4()}.${extension}`,
                    file: file,
                    url: URL.createObjectURL(file),
                };
            });
            setFileList([...fileList, ...list]);
            setAddedFiles([...addedFiles, ...list.map(x => x.id)]);
        }
    };
    return (react_1.default.createElement(core_1.FormControl, { className: classes.formHelpers },
        react_1.default.createElement(FieldHeader_1.default, { title: label, canSave: true, onDonePress: onDonePress, onCancelPress: onCancelPress, canSaveActive: !!fileList.length, doneButtonText: "Add" }),
        react_1.default.createElement(core_1.Box, { pt: 3, className: classes.content },
            react_1.default.createElement(CaptureArea, { captureLabel: captureLabel, fileUploadLabel: fileUploadLabel, deviceUploadLabel: deviceUploadLabel, captureType: captureType, setCaptureType: setCaptureType, camera: camera, setCamera: setCamera }),
            react_1.default.createElement(UploadCount, { max: max, min: min, length: fileList.length }),
            captureType === Capture.DEVICE_CAMERA && camera === CameraOptions.SYSTEM_CAMERA ? (renderMedia && renderMedia(addFileToList)) : (react_1.default.createElement(DropZone, { dragLabel: dragLabel, allowedTypes: allowedTypes, updateFileList: updateFileList, error: uploadError, mediaType: mediaType })),
            react_1.default.createElement(TGPreviewFieldWeb_1.default, { files: fileList, onModal: true, thumbnailSize: 100, onDelete: onDeleteFile }))));
};
const DefaultView = props => {
    const { min, max, removeFiles, files, readOnly, warning } = props;
    const [tooltip, setTooltip] = react_1.useState(false);
    const classes = CommonWeb_1.useStyles();
    return (react_1.default.createElement("div", { onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(DialogWrapperWeb_1.default, Object.assign({}, props, { clearValue: () => removeFiles(files.map(file => file.id)), position: 'bottom', renderHeader: () => {
                return (react_1.default.createElement("div", { className: classes.mediaInput },
                    react_1.default.createElement(core_1.InputLabel, { error: props.error, className: clsx_1.default(warning && classes.warningText) },
                        react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, error: props.error, style: classes.labelWrapper })),
                    react_1.default.createElement(UploadCount, { min: min, max: max, length: files.length, readOnly: readOnly })));
            }, renderMiddleValue: () => {
                return (react_1.default.createElement("div", { className: classes.imageCountText },
                    files.length,
                    " Image(s) Added"));
            }, renderValue: () => {
                return (react_1.default.createElement("div", null,
                    !!files.length && (react_1.default.createElement(TGPreviewFieldWeb_1.default, { files: files, thumbnailSize: 80, onModal: true, onDelete: id => removeFiles([id]) })),
                    react_1.default.createElement(core_1.FormHelperText, { error: props.error, className: clsx_1.default(classes.errorTxt, warning && classes.warningText) }, props.helperText)));
            }, renderComponent: toggleModal => {
                return react_1.default.createElement(TGMediaFieldWeb, Object.assign({}, props, { toggleModal: toggleModal }));
            } }))));
};
exports.default = DefaultView;
//# sourceMappingURL=TGMediaFieldWeb.js.map